import Vue from 'vue'
import Router from 'vue-router'

import AlibabaOrder from './views/AlibabaOrder.vue'
import IdentityVerification from './views/IdentityVerification.vue'
import ValidIdentity from './views/ValidIdentity.vue'
import Profile from './views/Profile.vue'
import OrderDone from './views/OrderDone.vue'
import Pay from './views/Pay.vue'
import TrialOperation from './views/TrialOperation.vue'
import Orders from './views/Orders.vue'
import ShoppingCart from './views/ShoppingCart.vue'
import Level from './views/Level.vue'
import TwStore from './views/TwStore.vue'
import TwStoreVender from './views/TwStoreVender.vue'
import TwShoppingCart from './views/TwShoppingCart.vue'
import TwShippingProfile from './views/TwShippingProfile.vue'
import TwOrderDone from './views/TwOrderDone.vue'
import TwOrders from './views/TwOrders.vue'
import InputAlibabaProd from './views/InputAlibabaProd.vue'
import QueryInputAlibabaProds from './views/QueryInputAlibabaProds.vue'
import ValidIdentityManual from './views/ValidIdentityManual.vue'

import ProfileV2 from './views/ProfileV2.vue'
import AlibabaOrderV2 from './views/AlibabaOrderV2.vue'
import OrderDoneV2 from './views/OrderDoneV2.vue'
import OrdersV2 from './views/OrdersV2.vue'
import PayV2 from './views/PayV2.vue'
import IdentityVerificationV2 from './views/IdentityVerificationV2.vue'

import AlibabaOrderV1_1 from './views/AlibabaOrderV1.1.vue'
import ProfileV1_1 from './views/ProfileV1.1.vue'
import PayV1_1 from './views/PayV1.1.vue'
import IdentityVerificationV1_1 from './views/IdentityVerificationV1.1.vue'
import ShoppingCartV1_1 from './views/ShoppingCartV1.1.vue'
import TrialOperationV1_1 from './views/TrialOperationV1.1.vue'

import Wallet from './views/Wallet.vue'

import UserFrom from './views/UserFrom.vue'

import RecommendCode from './views/RecommendCode.vue'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/identityverification',
      name: 'identityverification',
      component: IdentityVerification,
    },
    {
      path: '/identityverificationv1.1',
      name: 'identityverificationv1.1',
      component: IdentityVerificationV1_1,
    },
    {
      path: '/identityverificationv2',
      name: 'identityverificationv2',
      component: IdentityVerificationV2,
    },
    {
      path: '/level',
      name: 'level',
      component: Level,
    },
    {
      path: '/wallet',
      name: 'wallet',
      component: Wallet,
    },
    {
      path: '/trialoperation',
      name: 'trialoperation',
      component: TrialOperation,
    },
    {
      path: '/trialoperationv1.1',
      name: 'trialoperationv1.1',
      component: TrialOperationV1_1,
    },
    {
      path: '/shoppingcart',
      name: 'shoppingcart',
      component: ShoppingCart,
    },
    {
      path: '/shoppingcartv1.1',
      name: 'shoppingcartv1.1',
      component: ShoppingCartV1_1,
    },
    {
      path: '/orders',
      name: 'orders',
      component: Orders,
    },
    {
      path: '/ordersv2',
      name: 'ordersv2',
      component: OrdersV2,
    },
    {
      path: '/valididentity',
      name: 'valididentity',
      component: ValidIdentity,
    },
    {
      path: '/validIdentitymanual',
      name: 'validIdentitymanual',
      component: ValidIdentityManual,
    },
    {
      path: '/alibabaorder',
      name: 'alibabaorder',
      component: AlibabaOrder,
    },
    {
      path: '/alibabaorderv1.1',
      name: 'alibabaorderv1.1',
      component: AlibabaOrderV1_1,
    },
    {
      path: '/alibabaorderv2',
      name: 'alibabaorderv2',
      component: AlibabaOrderV2,
    },
    {
      path: '/profile',
      name: 'profile',
      component: Profile,
    },
    {
      path: '/profilev1.1',
      name: 'profilev1.1',
      component: ProfileV1_1,
    },
    {
      path: '/profilev2',
      name: 'profilev2',
      component: ProfileV2,
    },
    {
      path: '/orderdonev2',
      name: 'orderdonev2',
      component: OrderDoneV2,
    },
    {
      path: '/orderdone',
      name: 'orderdone',
      component: OrderDone,
    },
    {
      path: '/pay',
      name: 'pay',
      component: Pay,
    },
    {
      path: '/payv1.1',
      name: 'payv1.1',
      component: PayV1_1,
    },
    {
      path: '/payv2',
      name: 'payv2',
      component: PayV2,
    },
    {
      path: '/twstore',
      name: 'twstore',
      component: TwStore,
    },
    {
      path: '/twstorevender',
      name: 'twstorevender',
      component: TwStoreVender,
    },
    {
      path: '/twshoppingcart',
      name: 'twshoppingcart',
      component: TwShoppingCart,
    },
    {
      path: '/twshippingprofile',
      name: 'twshippingprofile',
      component: TwShippingProfile,
    },
    {
      path: '/tworderdone',
      name: 'tworderdone',
      component: TwOrderDone,
    },
    {
      path: '/tworders',
      name: 'tworders',
      component: TwOrders,
    },
    {
      path: '/inputalibabaorder',
      name: 'inputalibabaorder',
      component: InputAlibabaProd,
    },
    {
      path: '/queryinputalibabaprods',
      name: 'queryinputalibabaprods',
      component: QueryInputAlibabaProds,
    },
    {
      path: '/userfrom',
      name: 'userfrom',
      component: UserFrom,
    },
    {
      path: '/recommendcode',
      name: 'recommendcode',
      component: RecommendCode,
    },
  ],
})
